<div class="preview-container model__container">
  <mat-dialog-content #scrollMe (scroll)="onScroll(scrollMe)">
    <div class="mainClass" #pdfWrapper>
      <h2 mat-dialog-title>Credentialing Application</h2>

      <div *ngIf="loading" class="loader">Loading...</div>

      <div *ngIf="!loading && mergedData">
        <!-- Dentist Info -->
        <section class="demo-section">
          <h3>Dentist Info</h3>
          <div class="two-col">
            <div><strong>NPI:</strong></div>
            <div>{{ mergedData.dentistInfo?.npi || "NA" }}</div>

            <div><strong>License:</strong></div>
            <div> {{ mergedData.dentistInfo?.licenseNumber ?? "NA" }}</div>

            <div><strong>License State:</strong></div>
            <div> {{ mergedData.dentistInfo?.licenseState || "NA"}}</div>
          </div>
        </section>

        <!-- Demographics -->
        <section class="demo-section">
          <h3>Demographics</h3>

          <div class="two-col">
            <div><strong>Name:</strong></div>
            <div>{{ ((mergedData.demographics?.firstName || "") + (mergedData.demographics?.lastName ? " " +
              mergedData.demographics?.lastName : '')) || "NA" }}</div>

            <div><strong>DOB:</strong></div>
            <div>{{ (mergedData.demographics?.DOB | date) || "NA" }}</div>

            <div><strong>Gender:</strong></div>
            <div>{{ mergedData.demographics?.gender ?? 'NA' }}</div>

            <div><strong>Email:</strong></div>
            <div>{{ mergedData.demographics?.email || "NA" }}</div>

            <div><strong>Dental School:</strong></div>
            <div> {{ mergedData.demographics?.dentalSchool || "NA" }}</div>

            <div><strong>Degree:</strong></div>
            <div> {{ mergedData.demographics?.degree ?? 'NA'}}</div>

            <div><strong>Year Graduated:</strong></div>
            <div> {{ mergedData.demographics?.yearGraduated ?? 'NA' }}</div>

            <div><strong>Specialty:</strong></div>
            <div> {{ mergedData.demographics?.speciality || 'NA'}}</div>

            <div><strong>Ethnicity:</strong></div>
            <div> {{ mergedData.demographics?.ethnicity ?? 'NA'}}</div>

            <div><strong>Address:</strong></div>
            <div>
              {{ ((mergedData.demographics?.address1 || "") +
                (mergedData.demographics?.address2 ? "," + mergedData.demographics?.address2 : "")) || "NA" }}
            </div>
            <div><strong>City:</strong></div>
            <div> {{ mergedData.demographics?.city ?? 'NA' }}</div>

            <div><strong>State:</strong></div>
            <div> {{ mergedData.demographics?.state ?? 'NA' }} </div>

            <div><strong>Zip:</strong></div>
            <div> {{ mergedData.demographics?.zip ?? 'NA' }} </div>

          </div>
        </section>

        <!-- Credentials -->
        <section class="demo-section">
          <h3>Credentials</h3>
          <div class="two-col" *ngFor="let qa of mergedData.credentials">
            <div><strong>State License:</strong></div>
            <div>{{ qa.stateLicenseNumber ?? 'NA' }}</div>

            <div><strong>State License Effective Date:</strong></div>
            <div>{{ (qa.stateLicenseEffectiveDate | date) || "NA" }}</div>

            <div><strong>CDS License:</strong></div>
            <div>{{ qa.cdsLicenseNumber || 'NA' }}</div>

            <ng-container *ngIf="qa?.cdsLicenseNumber">
              <div><strong>CDS License Expiration Date:</strong></div>
              <div>{{ (qa.cDSExpirationDate | date) || "NA" }}</div>
            </ng-container>

            <div ><strong>DEA License:</strong></div>
            <div>{{ qa.deaLicenseNumber || 'NA' }}</div>

            <ng-container *ngIf="qa?.deaLicenseNumber">
              <div><strong>DEA License Expiration Date:</strong></div>
              <div>{{ (qa.dEAExpirationDate | date) || "NA" }}</div>
            </ng-container>

            <div><strong>Pain Management Note:</strong></div>
            <div>{{qa.painManagementNote ?? 'NA' }}</div>

            <div><strong>Specialty License:</strong></div>
            <div>{{ qa.specialtyLicenseNumber || 'NA' }}</div>

              <div><strong>Malpractice Expiration Date:</strong></div>
              <div>{{ (qa.malpracticeExpirationDate | date) || "NA" }}</div>
            
            <ng-container *ngIf="qa?.anesthesiaSedationLicense">
              <div><strong>Anesthesia License:</strong></div>
              <div>{{ qa.anesthesiaSedationLicense ?? 'NA' }}</div>
            </ng-container>

            <div><strong>Policy Type:</strong></div>
            <div>{{ qa.malpracticePolicyType ?? 'NA' }}</div>

            <div><strong>Carrier Name:</strong></div>
            <div>{{ qa.malpracticeCarrierName ?? 'NA' }}</div>

            <div><strong>Policy Holder:</strong></div>
            <div>{{ qa.malpracticePolicyHolder ?? 'NA' }}</div>

            <div><strong>Limit Per Claim:</strong></div>
            <div>{{ qa.malpracticeLimitPerClaim ? '$'+(qa.malpracticeLimitPerClaim | number:'1.2-2') : 'NA' }}</div>

            <div><strong>Limit Aggregate:</strong></div>
            <div>{{ qa.malpracticeLimitAggregate ? '$'+(qa.malpracticeLimitAggregate | number:'1.2-2') : 'NA' }}</div>


          </div>
        </section>

        <!-- Locations -->
        <section class="demo-section">
          <h3>Locations</h3>
          <div class="two-col" *ngFor="let qa of mergedData.locations; let i = index">
            <div><strong>Location #{{ i + 1 }}</strong></div>
            <div></div>
            <div><strong>Name:</strong></div>
            <div>{{ qa.name || "NA" }}</div>
            <div><strong>TIN:</strong></div>
            <div>{{ qa.tin || "NA" }}</div>

            <div><strong>Address:</strong></div>
            <div>
              {{ ((qa.address1 || "") + (qa.address2 ? ", " + qa.address2 : "")) || "NA" }}
            </div>
            <div><strong>City:</strong></div>
            <div> {{ qa.city ?? 'NA' }}</div>

            <div><strong>State:</strong></div>
            <div> {{ qa.state ?? 'NA' }} </div>

            <div><strong>Zip:</strong></div>
            <div> {{ qa.zip ?? 'NA' }} </div>

            <div><strong>Is Primary:</strong></div>
            <div> {{ qa.isPrimary ? 'Yes' : 'No' }} </div>

            <div><strong>Still Practicing:</strong></div>
            <div> {{ getIsPracticingLabel(qa) }} </div>

            <div><strong>Is Participating:</strong></div>
            <div> {{ qa.isParticipating ? 'Yes' : 'No'}} </div>
            <ng-container>
              <div><strong>Start Practicing At :</strong></div>
              <div> {{ (qa.startPracticingAt) || "NA" }} </div>
            </ng-container>
            <ng-container>
              <div><strong>End Practicing At :</strong></div>
              <div> {{ shouldShowEndedPracticingAt(qa) ? (qa.endedPracticingAt || qa.endDate || qa.endedDate) : "NA" }} </div>
            </ng-container>

            <!-- ✅ Location Directories (Questions) -->
            <div *ngIf="qa.isPrimary && qa.questions?.length" class="location-questions full-width">
              <h4 class="sub-heading">Directory Information</h4>
              <div *ngFor="let q of qa.questions" class="question-row">
                <div class="question-text">
                  <strong>{{ q.question }}</strong>
                </div>
                <div class="answer-text">
                  {{ q.answer }}
                </div>
              </div>
            </div>
            <hr />
          </div>
        </section>
        <!-- Locations -->
        <section class="demo-section">
          <h3>Work History</h3>
          <div class="two-col" *ngFor="let qa of (mergedData.workHistory?.length ? mergedData.workHistory : [{}])">
            <div><strong>Organization Name:</strong></div>
            <div>
              {{ displayWorkHistoryText(qa.organizationName == "My School Is Not Listed" ? qa.other : qa.organizationName) }}
              {{ qa.isSchool == true? "( School )":""}}
            </div>
            <ng-container *ngIf="!isGapWorkHistory(qa?.organizationName)">
              <div><strong>Address:</strong></div>
              <div>
                {{ displayWorkHistoryAddress(qa.address1, qa.address2) }}
              </div>
              <div><strong>City:</strong></div>
              <div> {{ displayWorkHistoryText(qa.city) }}</div>

              <div><strong>State:</strong></div>
              <div> {{ displayWorkHistoryText(qa.state) }} </div>

              <div><strong>Zip:</strong></div>
              <div> {{ displayWorkHistoryText(qa.zip) }} </div>

            </ng-container>
            <div><strong>Start Date:</strong></div>
            <div>{{ (qa.startDate | date) || 'NA' }}</div>
            <div><strong>End Date:</strong></div>
            <div>{{ (qa.endDate | date) || 'NA' }}</div>
            <hr />
          </div>
        </section>
        <!-- Attestation -->
        <section>
          <h3>Attestation</h3>
          <div *ngFor="let qa of mergedData.attestationQA">
            <div style="font-size:14px"><strong>Q:</strong> {{ qa.question }}</div>
            <div style="font-size:14px"><strong>A:</strong> {{ qa.response ? 'Yes' : 'No' }}</div>
            <ng-container *ngIf="qa?.explanation">
              <div style="font-size:14px"><strong>Explanation:</strong> {{ qa.explanation }}</div>
            </ng-container>
            <hr />
          </div>
        </section>
        <section *ngIf="isCallFromFinish">
          <h3>Credentialing Authorization, Attestation, and Release</h3>
          <div class="popup-right-txt">            
          <div class="attestinfo">
            <div class="attestContent"
                [innerHTML]="attestationContent || 'No content available'">
            </div>
          </div>
          </div>
        </section>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <div class="preview-actions" *ngIf="!isCallFromFinish">
      <button mat-button (click)="close()">Close</button>

      <!-- <button mat-raised-button color="primary" (click)="downloadPdf()">
      Download PDF
    </button> -->
    </div>

    <div class="finish-actions" *ngIf="isCallFromFinish">
      <button mat-button (click)="close()">Close</button>

      <button mat-raised-button color="primary" (click)="agreed()" [disabled]="!hasReadToBottom">
        I Agree
      </button>
    </div>

  </mat-dialog-actions>
</div>

